// extracted by mini-css-extract-plugin
export default {"lastElementContainer":"RegisterOverlay_lastElementContainer__MuqAG"};